import { useState } from 'react'
import { Button, CircularProgress, IconButton, Tooltip } from '@mui/material'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { saveDownload } from './download'

// Download for one version's full-size PNG (downloadTarget). The PNG can be
// tens of MB, so the button shows it is working until the file is saved, and
// hands a failure to the caller (`onError(serverReasonOrNull)`), which shows
// it where it fits (`onStart` clears it). `label` is the visible word;
// `iconOnly` keeps just the icon, with `label` as its name and tooltip.
export default function DownloadButton({ target, label, iconOnly = false, fetchResource, onStart, onError, size = 'medium' }) {
    const [saving, setSaving] = useState(false)

    async function download() {
        if (saving) return
        setSaving(true)
        onStart?.()
        let result
        try {
            result = await saveDownload(target.url, target.filename)
        } catch {
            result = { ok: false, error: null }
        } finally {
            setSaving(false)
        }
        // An expired session goes through the app's usual path: the session
        // check (the call App makes on load) answers UNAUTHORIZED, and
        // useFetch logs the reviewer out as it does for every other request.
        if (result.unauthorized) fetchResource?.({ method: 'GET', quiet: true })
        else if (!result.ok) onError?.(result.error)
    }

    if (iconOnly) {
        return (
            <Tooltip title={label}>
                <span>
                    <IconButton size='small' aria-label={label} disabled={saving} onClick={download} sx={{ p: 0.5 }}>
                        {saving ? <CircularProgress size={16} /> : <FileDownloadOutlinedIcon fontSize='small' />}
                    </IconButton>
                </span>
            </Tooltip>
        )
    }
    return (
        <Button
            variant='outlined'
            size={size}
            disabled={saving}
            onClick={download}
            startIcon={saving ? <CircularProgress size={16} color='inherit' /> : <FileDownloadOutlinedIcon />}
        >
            {label}
        </Button>
    )
}
